import { Component } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Message, MenuItem } from 'primeng/components/common/api';
import { SelectItem } from "primeng/components/common/selectitem";
import { AuthenticationService } from '../../../../../services/authentication/authentication.service';
import { StorageService } from '../../../../../services/system/storage.service';
import { UserService } from '../../../../../services/user/user.service';
import { BusinessService as BusinessCategoryService }
       from
  "../../../../../services/business/business-category.service";
import { LazyLoadEvent } from '../../../../../models/DataTables/lazyLoadEvent';
import { BusinessProfile } from "../../../../../models/inModels/BusinessProfile";
import { NotificationContentType, SendMessageToProfileModel, SendMessageToUserModel } from '../../../../../models/inModels/MessageModel';
import { User } from '../../../../../models/outModels/User';

@Component({
  selector: 'app-business-profile',
  templateUrl: './business-profile.component.html',
  styleUrls: ['./business-profile.component.css']
})
export class BusinessProfileComponent  {
    loading: boolean;
	loadingDialog: boolean;
	// Table data
	profiles: BusinessProfile[];
	error: Message[];
	// Total number of records
	totalRecords: number;
	filteredRecords: number;
	// Event to filter on row change
	rowEvent: LazyLoadEvent;
	rows: SelectItem[];
	selectedRows: number;
	selectedProfile: BusinessProfile;
	sendProfileModel: SendMessageToProfileModel;
    contentId: number;
	contentType: NotificationContentType;
    sendUserDialog = false;
    errorDialog: Message[];
    sending = false;
    selectedUser: User;

	uploading = false;
	importUrl: string;
  constructor(
    private route: ActivatedRoute,
		private router: Router,
		private userService: UserService,
		private auth: AuthenticationService,
		public storageService: StorageService,
    public businessService: BusinessCategoryService) {
    this.loading = true;

    this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;

	  this.sendProfileModel = new SendMessageToProfileModel();
	

		this.importUrl = userService.importUrl;
  }
  
  changeRows(event) {
    this.loadProfiles(this.rowEvent); 
  }

  loadProfiles(event) {
    this.loading = true;
    event.rows = this.selectedRows;
    this.rowEvent = event;
    this.businessService.getBusinessProfile(event).then(
      dataPager => {
        this.profiles = dataPager.Data;
        this.filteredRecords = dataPager.FilteredRecords;
        this.totalRecords = dataPager.TotalRecords;
        this.loading = false;
      },

      error => {
        this.loading = false;
        this.profiles = [];
        this.totalRecords = 0;
        this.filteredRecords = 0;
        this.error = [];
        this.error.push({ severity: 'error', summary: 'Error', detail: error });
      }
    )
  }

	sendDialogOpen(businessProfile: BusinessProfile) {
		this.selectedProfile = businessProfile;
		console.log(businessProfile)
		this.sendProfileModel.BusinessProfileId = businessProfile.Id;
		this.sendUserDialog = true;
	}
  sendUser() {
		this.sending = true;
		this.userService.sendMessageToProfile(this.sendProfileModel).then(
			result => {
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: `Message Sent to ${this.selectedProfile.RegisteredCompanyName}.` });
				this.sending = false;
				this.sendUserDialog = false;
				this.sendProfileModel.Subject = "";
				this.sendProfileModel.Message = "";
			},
			error => {
				this.sending = false;
				this.errorDialog = [];
				this.errorDialog.push({ severity: 'error', summary: 'Error', detail: error });
			});
  }
  download() {
	window.open(this.auth.apiUrl + "/api/business/profile/csv", "_blank");
}
}



// WEBPACK FOOTER //
// ./src/app/components/business/business-profile/business-profile/business-profile/business-profile.component.ts